import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { UserProp } from 'auth';
import Perms from 'auth/perms';
import Subscribe from 'subsys/notifications/subscribe';
import Form from 'containers/form';
import EditorLight from 'containers/form/extended/editor-light';

import translates from './comments-i18n.json';

const bemClasses = new Bem('commentsEditor');

@I18nHoc(translates)
export default class Editor extends Component {
  static propTypes = {
    className: PropTypes.string,
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    id: PropTypes.number,
    parent: PropTypes.number,
    formName: PropTypes.string,
    addMsg: PropTypes.string,
    onCommentSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func,
    reply: PropTypes.bool,
    formController: PropTypes.string,
    resetAfterSubmit: PropTypes.bool,
    updateEvent: PropTypes.string,
    updateCustomEvent: PropTypes.string,
    subscribe: PropTypes.bool,
    autoFocus: PropTypes.bool,
  };

  static defaultProps = {
    subscribe: true
  };

  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.subscriber = React.createRef();
  }

  handleSubmit(data) {
    if (this.props.checkPermission(Perms.COMMENTS_POST)) {
      this.props.onCommentSubmit(data);
      if (this.subscriber.current) {
        this.subscriber.current.doAction();
      }
    }
  }

  render() {
    const { i18n } = this;
    const {
      formController,
      entity,
      entityId,
      id,
      parent,
      addMsg,
      auth,
      actionDoLogin,
      className,
      resetAfterSubmit,
      updateEvent,
      updateCustomEvent,
      subscribe,
      autoFocus
    } = this.props;

    const otherProps = {
      resetAfterSubmit
    };
    if (id) {
      otherProps.entityId = id;
    }

    return (
      <div {...bemClasses({ extra: className })}>
        <Form
          {...bemClasses('form')}
          ref={el => this.form = el}
          defaultValues={{
            entity,
            entity_id: entityId,
            parent
          }}
          controller={formController}
          onSubmit={this.handleSubmit}
          defaultSuccessHeader={addMsg}
          updateEvent={[`comment::${entity}::${updateEvent}`, updateCustomEvent]}
          {...otherProps}
        >
          <EditorLight
            {...bemClasses('content')}
            dataBind="post"
            auth={auth}
            actionDoLogin={actionDoLogin}
            onCancel={this.props.onCancel}
            sendEnable
            focusLogin
            autoFocus={autoFocus}
            submitOnEnter
          />
          <div {...bemClasses('footer')}>
            {this.props.checkPermission(Perms.COMMENTS_POST) && subscribe &&
              <Subscribe
                {...bemClasses('subscribe')}
                ref={this.subscriber}
                type="comment"
                entity={entity}
                entity_id={entityId}
                mode="passive"
                passiveDefaultSubscribe
                labelSubscribe={i18n('commentsSubscribe')}
                labelUnsubscribe={i18n('commentsUnsubscribe')}
              />
            }
          </div>
        </Form>
      </div>
    );
  }
}
